var React = require('react');

function BlobLeft (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"blob__body","d":"M143.663 232.92C121.673 233.098 100.832 223.313 87.1516 206.389L18.114 120.983C-6.45971 90.5833 -1.31022 46.3171 29.6158 22.1119C60.5418 -2.09334 105.533 2.92843 130.107 33.3283L142.312 48.4274L234.899 160.655L199.78 205.48C186.349 222.623 165.654 232.743 143.663 232.92Z","fill":"#FFB6AB","key":0}),React.createElement("path",{"className":"blob__face","d":"M41.3622 63.1121C50.1713 68.102 58.0068 60.72 56.272 52.8938M63.4911 47.3046C72.3002 52.2945 80.1356 44.9125 78.4008 37.0863M37.5951 78.3983C65.9042 85.4868 95.6536 65.5285 93.7198 39.3447","stroke":"#FF553C","strokeWidth":"4.92264","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

BlobLeft.defaultProps = {"width":"274","height":"238","viewBox":"0 0 274 238","fill":"none"};

module.exports = BlobLeft;

BlobLeft.default = BlobLeft;
